import React from 'react'
import ScheduleSidebar from './sidebar/ScheduleSidebar'
import ScheduleCategoryView from './timeline/ScheduleCategoryView'
import WhiteLabel from '../leave_plan_benefits/shared/WhiteLabel'
import EmployeeFooter from '../EmployeeFooter'
import ScheduleTimelineView from './timeline/ScheduleTimelineView'
import ScheduleCalendarView from './common_components/ScheduleCalendarView'
import CustomItemModalBox from './common_components/CustomItemModalBox'
import JustLookingModalBox from '../leave_plan_benefits/shared/JustLookingModalBox'
import LeavePlanTitle from '../dashboard/LeavePlanTitle'

class ScheduleContent extends React.Component {
  constructor (props) {
    super (props)

    this.state = {
      calendar_data: props.calendar_data.data,
      calendar_requested_date: props.calendar_data.requested_date,
      timeline_data: this.manageTimelineItem(),
      category_data: props.category_data.data,
      timeline_requested_date: props.timeline_data.requested_date,
      last_event_included: props.timeline_data.last_event_included,
      leave_planning: false,
      short_term_disability: false,
      benefits: false,
      returning_to_work: false,
      lactation_support: false,
      childcare: false,
      show_paid_leave: true,
      show_job_protected_leave: true,
      show_hidden_tasks: false,
      show_essential_tasks: true,
      show_recommended_tasks: true,
      show_information_only_tasks: true,
      show_completed_tasks: false,
      display_modal: {
        taskTab: {
          item_id: '',
          item_type: '',
          lookUpField: ''
        },
        calendarTab: {
          item_id: '',
          item_type: '',
          lookUpField: ''
        }
      },
      viewTab: props.view_tab || "category",
      summary_date: props.summary_date,
      activate_leave_plan_modal: false,
      custom_task_modal: ''
    }

    this.taskCategories = [
      'Ready To Complete',
      'Due Today',
      'Due Later This Week',
      'Due Later This Month',
      'Upcoming',
      'Completed'
    ]
    this.infoTexts = [
      'View Task Details',
      'Add Voluntary Tasks to your LeavePlan',
      'Set reminders for important tasks',
      'Enable sharing of key LeavePlan details with your Manager and HR (you share when you\'re ready)'
    ]
  }

  newTimelineData() {
    return[{
      title: 'Ready To Complete',
      date: moment().subtract(1, "days").format("YYYY-MM-DD"),
      data: {
        timeline_events: {
          uncompleted_items: [],
          completed_items: []
        }
      },
      requested_month: false
    }]
  }

  manageTimelineItem() {
    let timelineData = this.newTimelineData()
    this.props.timeline_data.data.forEach(data => {
      if(data.date <= moment().subtract(1, "days").format("YYYY-MM-DD")) {
        let { completed_items, uncompleted_items } = timelineData[0].data.timeline_events
        timelineData[0].data.timeline_events.completed_items = completed_items.concat(data.data.timeline_events.completed_items)
        timelineData[0].data.timeline_events.uncompleted_items = uncompleted_items.concat(data.data.timeline_events.uncompleted_items)
      } else {
        timelineData.push(data)
      }
    })
    return timelineData
  }

  changeContentOnTabChange (tab) {
    const params = { leave_plan: tab }
    $.post(`/employees/${this.props.employee_id}/update_view_preferences`, { view_tab: params }, )
    const tabs = {
      calendar: {
        summary_date: '',
        viewTab: "calendar"
      },
      timeline: {
        summary_date: '',
        viewTab: "timeline"
      },
      category: {
        summary_date: '',
        viewTab: "category"
      }
    }

    window.history.replaceState({}, 'LeaveLogic', '/schedules')
    this.resetDisplayModal()
    this.setState(tabs[tab])
  }

  resetDisplayModal () {
    const displayModal = {
      taskTab: {
        item_id: '',
        item_type: '',
        lookUpField: ''
      },
      calendarTab: {
        item_id: '',
        item_type: '',
        lookUpField: ''
      }
    }
    this.setState({display_modal: displayModal})
  }

  filterStates () {
    return {
      leave_planning: this.state.leave_planning,
      short_term_disability: this.state.short_term_disability,
      benefits: this.state.benefits,
      returning_to_work: this.state.returning_to_work,
      lactation_support: this.state.lactation_support,
      childcare: this.state.childcare,
      show_completed_tasks: this.state.show_completed_tasks,
      show_hidden_tasks: this.state.show_hidden_tasks,
      show_paid_leave: this.state.show_paid_leave,
      show_job_protected_leave: this.state.show_job_protected_leave,
      show_essential_tasks: this.state.show_essential_tasks,
      show_recommended_tasks: this.state.show_recommended_tasks,
      show_information_only_tasks: this.state.show_information_only_tasks
    }
  }

  filterItems (stateName, stateStatus) {
    let obj = {}
    obj[stateName] = stateStatus
    this.setState(obj)
  }

  changeCalendarData (calendarData) {
    this.setState({
      calendar_data: calendarData.data,
      calendar_requested_date: calendarData.requested_date
    })
  }

  changeTimelineData (timelineData) {
    const previousData = this.state.timeline_data
    this.setState({
      timeline_data: previousData.concat(timelineData.data),
      timeline_requested_date: timelineData.requested_date,
      last_event_included: timelineData.last_event_included
    })
  }

  manageTimelineData (response) {
    this.setState({
      calendar_data: this.manageDataForCalendar(response.data),
      timeline_data: this.manageDataForTimeline(response.data),
      category_data: this.manageCategoryData(response)
    })
  }

  manageDataForCalendar (data) {
    let records = this.state.calendar_data
    records.map((weekRecord) => {
      return weekRecord.map((record) => {
        if (data.date == record.date) {
          let sourceKey = ''
          let destinationKey = ''
          if (data.check_status) {
            sourceKey = 'uncompleted_items'
            destinationKey = 'completed_items'
          } else {
            sourceKey = 'completed_items'
            destinationKey = 'uncompleted_items'
          }
          let source = record.data.timeline_events[sourceKey]
          let destination = record.data.timeline_events[destinationKey]
          let migratingData = source.filter((timelineItem) => {
            return parseInt(data.id) === parseInt(timelineItem.id)
          })[0]
          const index = source.indexOf(migratingData)
          if (index >= 0) {
            source.splice(index, 1)
            migratingData.check_status = data.check_status
            destination.push(migratingData)
            record.data.timeline_events[sourceKey] = source
            record.data.timeline_events[destinationKey] = destination
          }
          return record
        }
      })
    })
    return records
  }

  manageDataForTimeline (data) {
    let records = this.state.timeline_data
    records.map((record) => {
      if (data.date === record.date || this.timelineCategoryTask(data.date, record.title)) {
        let sourceKey = ''
        let destinationKey = ''
        if (data.check_status) {
          sourceKey = 'uncompleted_items'
          destinationKey = 'completed_items'
        } else {
          sourceKey = 'completed_items'
          destinationKey = 'uncompleted_items'
        }
        let source = record.data.timeline_events[sourceKey]
        let destination = record.data.timeline_events[destinationKey]
        let migratingData = source.filter((timelineItem) => {
          return parseInt(data.id) === parseInt(timelineItem.id)
        })[0]
        const index = source.indexOf(migratingData)
        if (index >= 0) {
          source.splice(index, 1)
          migratingData.check_status = data.check_status
          destination.push(migratingData)
          record.data.timeline_events[sourceKey] = source
          record.data.timeline_events[destinationKey] = destination
        }
        return record
      }
    })
    return records
  }

  manageCategoryData (response) {
    let timelineData = this.state.category_data
    const data = response.data
    let source = timelineData.filter((categorizedData) => {
      return categorizedData.category === response.previous_category
    })[0]
    const sourceIndex = timelineData.indexOf(source)
    if (source) {
      let migratingData = source.data.filter((timelineItem) => {
        return timelineItem.id === parseInt(data.id)
      })[0]
      const index = source.data.indexOf(migratingData)
      if (index >= 0) {
        source.data.splice(index, 1)
        migratingData.check_status = data.check_status
        timelineData = this.handleNewTaskItemCategory(response)
        timelineData[sourceIndex] = source
      }
    }
    return timelineData
  }

  handleItemClick (item_type, item_id, description, image_url, association, lookUpField, itemFiles) {
    let display_modal = this.state.display_modal
    let tab = ''
    if (this.state.viewTab == 'calendar') {
      tab = 'calendarTab'
    } else {
      tab = 'taskTab'
    }
    display_modal[tab] = {
      item_type: item_type,
      item_id: item_id,
      description: description,
      image_url: image_url,
      association: association,
      lookUpField: lookUpField,
      itemFiles: itemFiles
    }
    this.setState({display_modal})
  }

  manageHelpfulDataForTimeline (date, data) {
    let records = this.state.timeline_data
    records.forEach((record, i) => {
      if (date === record.date || this.timelineCategoryTask(date, record.title)) {
        let task_type = data.checked ?  'completed_items' : 'uncompleted_items'
        let index = ''
        let timeline_items = records[i].data.timeline_events[task_type]
        timeline_items.map((item, ind) => {
          if (item.timeline_id === parseInt(data.item_id)) {
            index = ind
            return false
          }
        })
        if (data.hasOwnProperty('visibility')) {
          timeline_items[index].visible = data.visibility
        } else {
          timeline_items[index].helpful = data.helpful
        }
      }
    })
    return records
  }

  manageHelpfulDataForCategory (data) {
    const categoryData = this.state.category_data
    return categoryData.map((categorizedData) => {
      if (categorizedData.category === data.category) {
        categorizedData.data = categorizedData.data.map((categoryItem) => {
          if (categoryItem.timeline_id === parseInt(data.item_id)) {
            if (data.hasOwnProperty('visibility')) {
              categoryItem.visible = data.visibility
            } else {
              categoryItem.helpful = data.helpful
            }
          }
          return categoryItem
        })
      }
      return categorizedData
    })
  }

  manageHelpfulDataForCalendar (date, data) {
    let records = this.state.calendar_data
    records.forEach((weekRecord, i) => {
      weekRecord.forEach((record, j) => {
        if (date === record.date) {
          let taskType = ''
          if (data.checked) {
            taskType = 'completed_items'
          } else {
            taskType = 'uncompleted_items'
          }
          let index = ''
          let timeline_items = records[i][j].data.timeline_events[taskType]
          timeline_items.forEach((item, ind) => {
            if (item.timeline_id === parseInt(data.item_id)) {
              index = ind
              return false
            }
          })
          if (data.hasOwnProperty('visibility')) {
            timeline_items[index].visible = data.visibility
          } else {
            timeline_items[index].helpful = data.helpful
          }
        }
      })
    })
    return records
  }

  manageBenefitHelpfulDataForCalendar (date, data) {
    let records = this.state.calendar_data
    let taskType = ''
    if (data.paid_leave) {
      taskType = 'paid_benefits'
    } else {
      taskType = 'job_protected_benefits'
    }
    return records.map((weekRecord) => {
      return weekRecord.map((record) => {
        const benefitEvents = record.data.benefit_events[taskType].map((item) => {
          if (item.id === parseInt(data.item_id)) {
            item.helpful = data.helpful
          }
          return item
        })
        record.data.benefit_events[taskType] = benefitEvents
        return record
      })
    })
  }

  onHelpfulCheck (date, data) {
    if (data.item_type === 'timeline_event') {
      this.setState({
        timeline_data: this.manageHelpfulDataForTimeline(date, data),
        calendar_data: this.manageHelpfulDataForCalendar(date, data),
        category_data: this.manageHelpfulDataForCategory(data)
      })
    } else {
      this.setState({calendar_data: this.manageBenefitHelpfulDataForCalendar(date, data)})
    }
  }

  handleOnTaskSearch (filteredTasks) {
    if (!gon.all_tasks) {
      gon.all_tasks = true
      gon.category_tasks = this.state.category_data
      gon.timeline_tasks = this.state.timeline_data
      gon.last_event_included = this.state.last_event_included
    }
    this.setState({
      timeline_data: filteredTasks.timeline_data.data,
      category_data: filteredTasks.category_data.data,
      last_event_included: true
    })
  }

  handleOnAllTask () {
    if (gon.all_tasks) {
      this.setState({
        timeline_data: gon.timeline_tasks,
        category_data: gon.category_tasks,
        last_event_included: gon.last_event_included
      })
      gon.all_tasks = gon.last_event_included = null
    }
  }

  handleJustLookingClick (value) {
    this.setState({activate_leave_plan_modal: value})
  }

  eventType (completed) {
    return completed ? 'completed_items' : 'uncompleted_items'
  }

  handleCustomTaskClick (id) {
    if (this.props.just_looking) {
      this.handleJustLookingClick(true)
    } else {
      this.setState({custom_task_modal: id})
    }
  }

  removeItemFromIndex (items, data) {
    return items.filter((item) => {
      return item.timeline_id !== parseInt(data.id)
    })
  }

  handleNewTaskItem (response) {
    this.setState({
      timeline_data: this.handleNewTaskItemTimeline(response.data),
      category_data: this.handleNewTaskItemCategory(response),
      calendar_data: this.handleNewTaskItemCalendar(response.data)
    })
  }

  handleNewTaskItemTimeline (response) {
    let timelineDatas = this.state.timeline_data
    return timelineDatas.map((timelineData) => {
      if (response.date === timelineData.date || this.timelineCategoryTask(response.date, timelineData.title)) {
        timelineData.data.timeline_events['uncompleted_items'].push(response)
      }
      return timelineData
    })
  }

  timelineCategoryTask (date, title) {
    return title && date < moment().subtract(1, "days").format("YYYY-MM-DD")
  }

  handleNewTaskItemCategory (response) {
    let categoryData = this.state.category_data
    let categoryFound = false
    categoryData.map((categorizedData) => {
      if (categorizedData.category === response.current_category) {
        categoryFound = true
        categorizedData.data.push(response.data)
      }
      return categorizedData
    })
    if (!categoryFound) {
      const record = {
        category: response.current_category,
        data: [response.data]
      }
      categoryData.push(record)
    }
    return categoryData
  }

  handleNewTaskItemCalendar (data) {
    let records = this.state.calendar_data
    return records.map((weekRecord) => {
      return weekRecord.map((record) => {
        if (data.date === record.date) {
          record.data.timeline_events['uncompleted_items'].push(data)
        }
        return record
      })
    })
  }

  handleUpdatedTaskTimeline (response) {
    let timelineData = this.state.timeline_data
    timelineData = this.handleCustomTaskDeleteTimeline(response)
    timelineData = this.handleNewTaskItemTimeline(response.data)
    return timelineData
  }

  handleUpdatedTaskCategory (response) {
    let categoryData = this.state.category_data
    categoryData = this.handleCustomTaskDeleteCategory(response)
    categoryData = this.handleNewTaskItemCategory(response)
    return categoryData
  }

  handleUpdatedTaskCalendar (response) {
    let calendarData = this.state.calendar_data
    calendarData = this.handleCustomTaskDeleteCalendar(response)
    calendarData = this.handleNewTaskItemCalendar(response.data)
    return calendarData
  }

  handleCustomTaskUpdate (response) {
    this.setState({
      timeline_data: this.handleUpdatedTaskTimeline(response),
      category_data: this.handleUpdatedTaskCategory(response),
      calendar_data: this.handleUpdatedTaskCalendar(response)
    })
  }

  handleCustomTaskDelete (data) {
    this.setState({
      timeline_data: this.handleCustomTaskDeleteTimeline(data),
      category_data: this.handleCustomTaskDeleteCategory(data),
      calendar_data: this.handleCustomTaskDeleteCalendar(data)
    })
  }

  handleCustomTaskDeleteTimeline (data) {
    let timelineDatas = this.state.timeline_data
    timelineDatas.map((timelineData) => {
      let timeline_items = timelineData.data.timeline_events
      const taskType = this.eventType(data.checked)
      if (data.date === timelineData.date || this.timelineCategoryTask(data.date, timelineData.data)) {
        timeline_items[taskType] = this.removeItemFromIndex(timeline_items[taskType], data)
      }
      return timelineData
    })
    return timelineDatas
  }

  handleCustomTaskDeleteCategory (data) {
    let categoryData = this.state.category_data
    categoryData.map((categorizedData) => {
      if (categorizedData.category === data.previous_category) {
        categorizedData.data = this.removeItemFromIndex(categorizedData.data, data)
      }
      return categorizedData
    })
    return categoryData
  }

  handleCustomTaskDeleteCalendar (data) {
    let records = this.state.calendar_data
    return records.map((weekRecord) => {
      return weekRecord.map((record) => {
        let timeline_items = record.data.timeline_events
        const taskType = this.eventType(data.checked)
        if (data.date == record.date) {
          timeline_items[taskType] = this.removeItemFromIndex(timeline_items[taskType], data)
        }
        return record
      })
    })
  }

  buildTimelineData (data) {
    return this.taskCategories.map((category) => {
      return data.filter((categorizedData) => {
        return categorizedData.category === category
      })
    }).flatten().filter((categorizedData) => {
      return categorizedData
    })
  }

  renderScheduleCalendarOrTimelineView () {
    if (this.state.viewTab == 'calendar') {
      return (
        <ScheduleCalendarView
          data={this.state.calendar_data}
          requested_date={this.state.calendar_requested_date}
          changeData={this.changeCalendarData.bind(this)}
          manageTimelineData={this.manageTimelineData.bind(this)}
          handleItemClick={this.handleItemClick.bind(this)}
          display_modal={this.state.display_modal.calendarTab}
          show_paid_leave={this.state.show_paid_leave}
          show_job_protected_leave={this.state.show_job_protected_leave}
          summary_date={this.state.summary_date}
          onHelpfulCheck={this.onHelpfulCheck.bind(this)}
          handleJustLookingClick={this.handleJustLookingClick.bind(this)}
          show_hidden_tasks={this.state.show_hidden_tasks}
          handleCustomTaskDelete={this.handleCustomTaskDelete.bind(this)}
          handleCustomTaskClick={this.handleCustomTaskClick.bind(this)}
          custom_task_modal={this.state.custom_task_modal}
          handleCustomTaskChange={this.handleCustomTaskUpdate.bind(this)}
          isLeavePlanPartner={this.props.isLeavePlanPartner}
        />
      )
    } else if (this.state.viewTab == 'timeline') {
      return (
        <ScheduleTimelineView
          data={this.state.timeline_data}
          requested_date={this.state.timeline_requested_date}
          lastEventIncluded={this.state.last_event_included}
          manageTimelineData={this.manageTimelineData.bind(this)}
          onScrollToBottom={this.changeTimelineData.bind(this)}
          handleItemClick={this.handleItemClick.bind(this)}
          display_modal={this.state.display_modal.taskTab}
          summary_date={this.state.summary_date}
          onHelpfulCheck={this.onHelpfulCheck.bind(this)}
          handleJustLookingClick={this.handleJustLookingClick.bind(this)}
          show_hidden_tasks={this.state.show_hidden_tasks}
          handleCustomTaskDelete={this.handleCustomTaskDelete.bind(this)}
          handleCustomTaskChange={this.handleCustomTaskUpdate.bind(this)}
          handleCustomTaskClick={this.handleCustomTaskClick.bind(this)}
          custom_task_modal={this.state.custom_task_modal}
          show_essential_tasks={this.state.show_essential_tasks}
          show_recommended_tasks={this.state.show_recommended_tasks}
          show_information_only_tasks={this.state.show_information_only_tasks}
          isLeavePlanPartner={this.props.isLeavePlanPartner}
          disabledTaskEmailNotifications={this.props.disabledTaskEmailNotifications}
        />
      )
    } else {
      return (
        <ScheduleCategoryView
          data={this.buildTimelineData(this.state.category_data)}
          requested_date={this.state.timeline_requested_date}
          lastEventIncluded={this.state.last_event_included}
          manageTimelineData={this.manageTimelineData.bind(this)}
          handleItemClick={this.handleItemClick.bind(this)}
          display_modal={this.state.display_modal.taskTab}
          summary_date={this.state.summary_date}
          onHelpfulCheck={this.onHelpfulCheck.bind(this)}
          handleJustLookingClick={this.handleJustLookingClick.bind(this)}
          show_hidden_tasks={this.state.show_hidden_tasks}
          handleCustomTaskDelete={this.handleCustomTaskDelete.bind(this)}
          handleCustomTaskChange={this.handleCustomTaskUpdate.bind(this)}
          handleCustomTaskClick={this.handleCustomTaskClick.bind(this)}
          custom_task_modal={this.state.custom_task_modal}
          show_essential_tasks={this.state.show_essential_tasks}
          show_recommended_tasks={this.state.show_recommended_tasks}
          show_information_only_tasks={this.state.show_information_only_tasks}
          isLeavePlanPartner={this.props.isLeavePlanPartner}
          disabledTaskEmailNotifications={this.props.disabledTaskEmailNotifications}
        />
      )
    }
  }

  renderJustLookingModalBox () {
    if (!this.state.activate_leave_plan_modal) {
      return null
    }

    return (
      <JustLookingModalBox
        handleJustLookingClose={this.handleJustLookingClick.bind(this)}
        infoTexts={this.infoTexts}
        buttons={{ cancel: 'Later', confirm: 'Activate Now' }}
      />
    )
  }

  renderCustomItemModalBox () {
    if (this.state.custom_task_modal !== 'new') {
      return null
    }

    return (
      <CustomItemModalBox
        handleCustomTaskClose={this.handleCustomTaskClick.bind(this)}
        handleNewTaskItem={this.handleNewTaskItem.bind(this)}
        disabledTaskEmailNotifications={this.props.disabledTaskEmailNotifications}
      />
    )
  }

  closeSideBar() {
    $("#wrapper").toggleClass("toggled")
  }

  render() {
    return (
      <div id='wrapper'>
        <div id='sidebar-wrapper'>
          <div id='sidebar-content'>
            <i className="fa fa-chevron-circle-left sidebar-toggle-mobile"
              aria-hidden="true"
              onClick={() => this.closeSideBar()}
              style={{
                float: 'right',
                marginTop: '-75px',
                marginRight: '-21px',
                color: '#123f6e',
                fontSize: 'x-large',
              }}
            ></i>
            <ScheduleSidebar
              handleTabChange={this.changeContentOnTabChange.bind(this)}
              filterStates={this.filterStates()}
              filterItems={this.filterItems.bind(this)}
              viewTab={this.state.viewTab}
              handleOnTaskSearch={this.handleOnTaskSearch.bind(this)}
              handleOnAllTasks={this.handleOnAllTask.bind(this)}
              handleCustomTaskClick={this.handleCustomTaskClick.bind(this)}
              isLeavePlanPartner={this.props.isLeavePlanPartner}
              taskCategories={this.taskCategories}
            />
            <WhiteLabel />
          </div>
        </div>
        <div id='page-content-wrapper'>
          <div className='page-content'>
            <div className='container-fluid'>
              <LeavePlanTitle
                title= {this.props.leave_plan_title}
                leave_plan_id= {this.props.leave_plan_id}
              />
              {this.renderScheduleCalendarOrTimelineView()}
            </div>
          </div>
          <EmployeeFooter disclaimerText={this.props.disclaimer_text} />
        </div>
        {this.renderJustLookingModalBox()}
        {this.renderCustomItemModalBox()}
      </div>
    )
  }
}

export default ScheduleContent;
